import React from "react";
import * as dc from "dc";
import {format} from 'd3';
import * as reductio from 'reductio';
import crossfilter from 'crossfilter2';

import { TotalTemplate } from "./totalTemplate";

//const self = this;
const barChartFunc = (divRef, ndx) => {
    const myChart = dc.numberDisplay(divRef);
    
    const teachers = ndx.dimension(function (d) {
      return d;
    });
    
    const UniqueProjectsGroup = teachers
      .group()
      .reduce(
        function (p, v) {
            if(v.project_id in p.ids){
              p.ids[v.project_id] += 1
            }
            else{
                p.ids[v.project_id] = 1;
                p.id_count++;
            }
            return p;
        },

        function (p, v) {
          if(v.project_id in p.ids){
            p.ids[v.project_id] -= 1
          }
            if(p.ids[v.project_id] === 0){
                delete p.ids[v.project_id];
                p.id_count--;
            }
            return p;
        },

        function () {
          return {
            ids: {},
            id_count: 0
          }
        }
      )

    myChart
    .formatNumber(format(",d"))
    .dimension(teachers)
    .group(UniqueProjectsGroup)
    .valueAccessor(function (p) {
       return p.value.id_count ;
     })
    .transitionDuration(800)


    return myChart
}

export class TotalAssigments extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <TotalTemplate chartFunction={barChartFunc} title={this.props.title}
        dim={this.props.dim} type={this.props.type} />

    );
  }
}
